/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { performCmdbGetRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getMyDataManagerRolesUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getCmdbConfigReferenceTypeUrl.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { ActionApi, MyRolesResponse } from './ActionApi.types.tsx';

export const fetchMyDataManagerRoles =
	(shouldRefetch = true): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		if (
			getState().dataManager.myRolesLoading ||
			(!shouldRefetch && getState().dataManager.myRoles)
		) {
			return;
		}
		setState({
			dataManager: { ...getState().dataManager, myRolesLoading: true, myRolesError: undefined },
		});

		try {
			const myRoles: MyRolesResponse = await performCmdbGetRequest(
				getMyDataManagerRolesUrl(workspaceId),
			);

			setState({
				dataManager: {
					...getState().dataManager,
					myRoles: myRoles.results,
					myRolesLoading: false,
				},
			});
			fireTrackAnalytics(createAnalyticsEvent({}), 'fetchMyDataManagerRoles succeeded');
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				dataManager: { ...getState().dataManager, myRolesLoading: false, myRolesError: error },
			});
			fireCmdbErrorAnalytics({
				meta: {
					id: 'fetchMyDataManagerRoles',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
				},
				error,
			});

			throw error;
		}
	};
